<template>
    <v-container class="flex-column pa-0 max-w-1200-350">
        <!-- 再エネでんきに切り替えるだけで～ -->
        <v-spacer class="spacing-h-28-36"/>
        <v-row>
            <v-col class="flex-center flex-column nowrap font-42-21 text-center bold">
                <div>
                    <span class="red">おうちの電気を</span>再エネにかえたら、
                </div>
                <div>
                    <span class="red">
                        <span class="font-45-28">CO</span>
                        <span class="font-24-20">2</span>
                    </span>
                    をどれだけ減らせる？
                    <span class="font-18-12">(※1)</span>
                </div>
            </v-col>
        </v-row>
        <v-spacer class="spacing-h-28-36"/>
        <!-------------------------------------------------- 
            ペットボトル、ガソリン、桜の木
         -------------------------------------------------->
        <v-row no-gutters class="flex-center">
            <!-- サマリ：画像（ペットボトル、ガソリン、桜の木） -->
            <v-row no-gutters :class="isSm ? 'flex-center space-between' : 'flex-center space-evenly'">
                <v-col md="3" cols="3">
                    <div class="flex-center flex-column h-150-150">
                        <div class="font-30-14 blue mb-1">ペットボトル</div>
                        <v-img class="w-200-90" :src="require('@/assets/fv/plasticBottle.svg')" />
                        <div>
                            <span class="font-64-32 blue">？</span>
                            <span class="font-30-12 blue">本分</span>
                        </div>
                    </div>
                </v-col>
                <v-col md="3" cols="3">
                    <div class="flex-center flex-column h-150-150">
                        <div class="font-30-14 blue mb-1">ガソリン</div>
                        <v-img class="w-370-130" :src="require('@/assets/fv/gasolene.svg')" />
                        <div class="nowrap">
                            <span class="font-64-32 blue">？</span>
                            <span class="font-30-12 blue">リットル分</span>
                        </div>
                    </div>
                </v-col>
                <v-col md="3" cols="3">
                    <div class="flex-center flex-column h-150-150">
                        <div class="font-30-14 blue mb-1">桜の木</div>
                        <v-img class="w-200-90" :src="require('@/assets/fv/tree.svg')" />
                        <div>
                            <span class="font-64-32 blue">？</span>
                            <span class="font-30-12 blue">本分</span>
                        </div>
                    </div>
                </v-col>
            </v-row>
        </v-row>
        <v-spacer class="spacing-h-28-36"/>
        <v-row v-if="!isSm && (currentPattern === 'a' || currentPattern === 'b' || currentPattern === '')" class="flex-column">
            <v-col class="flex-center">
                <v-img src="@/assets/fv/deco-left.svg" style="max-width: 30px; margin-right: 20px;" contain/>
                <span class="font-38-20">気になる<span class="red">電気代</span>は？</span>
                <v-img src="@/assets/fv/deco-right.svg" style="max-width: 30px; margin-left: 20px;" contain/>
            </v-col>
            <v-spacer class="spacing-h-8-8"/>
            <v-col class="flex-center">
                <v-btn class="simulation-btn relative-btn" @click="goToSearchWithDialog()">
                <!-- 左端固定アイコン -->
                <v-img
                    class="kaeru-btn"
                    :src="require('@/assets/fv/kaeru-btn.svg')"
                />
                <!-- テキスト部分 -->
                <div class="flex-center flex-column">
                    <div class="font-24-12">CO<span class="font-14-10">2</span>も電気代も！</div>
                    <div class="font-38-20">5秒で簡単チェック！</div>
                </div>
                <!-- 右端矢印 -->
                <v-icon right class="arrow-icon" size="70">mdi-arrow-right-circle</v-icon>
                </v-btn>
            </v-col>
        </v-row>
        <v-row v-if="!isSm && currentPattern === 'c'">
            <v-col class="flex-center">
                <v-btn class="simulation-btn relative-btn" @click="goToSearchWithDialog()">
                <!-- 左端固定アイコン -->
                <v-img
                    class="sm-kaeru-btn"
                    :src="require('@/assets/fv/kaeru-btn.svg')"
                />
                <!-- テキスト部分 -->
                <div class="flex-center flex-column">
                    <div class="font-24-12">CO<span class="font-14-10">2</span>も電気代も！</div>
                    <div class="font-38-20">5秒で簡単チェック！</div>
                </div>
                <!-- 右端矢印 -->
                <v-icon right class="arrow-icon" size="70">mdi-arrow-right-circle</v-icon>
                </v-btn>
            </v-col>
        </v-row>
        <v-row v-if="isSm && (currentPattern === 'a' || currentPattern === 'b' || currentPattern === '')" class="flex-column">
            <v-col class="flex-center">
                <v-img src="@/assets/fv/deco-left.svg" style="max-width: 30px; margin-right: 20px;" contain/>
                <span class="font-38-20">気になる<span class="red">電気代</span>は？</span>
                <v-img src="@/assets/fv/deco-right.svg" style="max-width: 30px; margin-left: 20px;" contain/>
            </v-col>
            <v-spacer class="spacing-h-8-8"/>
            <v-col class="flex-center">
                <v-btn class="sm-simulation-btn relative-btn" @click="goToSearchWithDialog()">
                <!-- 左端固定アイコン -->
                <v-img
                    class="sm-kaeru-btn"
                    :src="require('@/assets/fv/kaeru-btn.svg')"
                />
                <!-- テキスト部分 -->
                <div class="flex-center flex-column">
                    <div class="font-24-16">CO<span class="font-14-10">2</span>も電気代も！</div>
                    <div class="font-38-20">5秒で簡単チェック！</div>
                </div>
                <!-- 右端矢印 -->
                <v-icon right class="sm-arrow-icon" size="30">mdi-arrow-right-circle</v-icon>
                </v-btn>
            </v-col>
        </v-row>
        <v-row v-if="isSm && currentPattern === 'c'">
            <v-col class="flex-center">
                <v-btn class="sm-simulation-btn relative-btn" @click="goToSearchWithDialog()">
                <!-- 左端固定アイコン -->
                <v-img
                    class="sm-kaeru-btn"
                    :src="require('@/assets/fv/kaeru-btn.svg')"
                />
                <!-- テキスト部分 -->
                <div class="flex-center flex-column">
                    <div class="font-24-16">CO<span class="font-14-10">2</span>も電気代も！</div>
                    <div class="font-38-20">5秒で簡単チェック！</div>
                </div>
                <!-- 右端矢印 -->
                <v-icon right class="sm-arrow-icon" size="30">mdi-arrow-right-circle</v-icon>
                </v-btn>
            </v-col>
        </v-row>
        <!-- 固定表示ボタン -->
        <transition name="fade" v-if="isSm">
            <div v-if="showFloating" class="floating-banner" style="background: rgba(255, 255, 255, 0.8);">
                <v-row class="flex-column">
                    <v-col class="flex-center" v-if="currentPattern === 'a' || currentPattern === 'b' || currentPattern === ''">
                        <v-img src="@/assets/fv/deco-left.svg" style="max-width: 30px; margin-right: 20px;" contain/>
                        <span class="font-38-20">気になる<span class="red">電気代</span>は？</span>
                        <v-img src="@/assets/fv/deco-right.svg" style="max-width: 30px; margin-left: 20px;" contain/>
                    </v-col>
                    <v-spacer class="spacing-h-8-8"/>
                    <v-col class="flex-center">
                        <v-btn class="sm-simulation-btn relative-btn" @click="goToSearchWithDialog()">
                        <!-- 左端固定アイコン -->
                        <v-img
                            class="sm-kaeru-btn"
                            :src="require('@/assets/fv/kaeru-btn.svg')"
                        />
                        <!-- テキスト部分 -->
                        <div class="flex-center flex-column">
                            <div class="font-24-16">CO<span class="font-14-10">2</span>も電気代も！</div>
                            <div class="font-38-20">5秒で簡単チェック！</div>
                        </div>
                        <!-- 右端矢印 -->
                        <v-icon right class="sm-arrow-icon" size="30">mdi-arrow-right-circle</v-icon>
                        </v-btn>
                    </v-col>
                </v-row>
            </div>
        </transition>
        <v-spacer class="spacing-h-28-16"/>
        <!-- 注意書き -->
        <v-row class="flex-center font-24-14" id="section-terms">
            <u class="text-center">ご利用にあたっては必ず<a href="/terms">利用規約</a>をご確認ください。</u>
        </v-row>
        <v-spacer class="spacing-h-32-32"/>
        <v-row no-gutters>
            <v-col class="flex-center">
                <div class="text-left md-14 sm-12">
                    <p style="font-weight: normal !important;">利用上のご注意</p>
                    <p style="font-weight: normal !important;">・本シミュレーションは、UCHIKARAプロジェクトパートナー企業のうち、シミュレーションサイトへの参加を希望した企業のシミュレーションを行います。</p>
                    <p style="font-weight: normal !important;">・本シミュレーションは、ユーザーが入力した情報および一般的な前提条件に基づき、世田谷区が独自に設定した条件<a href="/conditions"><u>（試算条件）</u></a>のもと試算した参考情報です。</p>
                    <p style="font-weight: normal !important;">・表示される金額等の結果は目安であり、実際の金額等を保証するものではありません。</p>
                    <p style="font-weight: normal !important;">・実際の契約内容や電気料金とは異なる場合があります。ご契約の際は、必ず各電力会社の公式情報をご確認ください。</p>
                    <p style="font-weight: normal !important;">・本シミュレーションは、中東情勢をはじめとする国際情勢の変化やそれに伴う影響を加味したものではありません。</p>
                    <p style="font-weight: normal !important;">・本サービスのご利用にあたっては、別途定める<a href="/terms"><u>利用規約</u></a>が適用されます。必ずご確認のうえご利用ください。</p>
                </div>
            </v-col>
        </v-row>
        <v-spacer class="spacing-h-40-24"/>
        <!-------------------------------------------------- 
            キャンペーン
         -------------------------------------------------->
        <!-- 9/30 キャンペーン終了対応に伴いコメントアウト -->
        <!-- キャンペーン実施中 -->
        <!-- <v-row id="section-campaign">
            <v-col class="pa-0 ma-0">
                <div class="text-center font-40-24 bold">
                    <span>最大<span class="font-55-32 red">15,000</span>円分還元される<br v-if="isSm">キャンペーン実施中！<br v-if="isSm">詳細は
                    </span>
                    <u style="text-decoration-color: var(--blue);">                        
                        <a style="color: var(--blue)" href="https://uchikara-setagaya.com/renewable/" rel="noopener noreferrer" target="_blank">
                            こちら
                        </a>
                    </u>
                </div>
            </v-col>
        </v-row> -->
        <!-- キャンペーン実施会社 -->
        <!-- <v-spacer class="spacing-h-40-24"/> -->
        <!-- <v-row class="flex-center">
            <span class="font-24-16" style="color: #828282;">キャンペーン実施会社</span>
        </v-row>
        <v-spacer class="spacing-h-16-16"/>
        <v-row :class="!isSm ? 'flex-center flex-start-y' : 'flex-center flex-start-y space-evenly'"> -->
            <!-- UPDATER -->
            <!-- <v-col class="flex-center max-w-200-170" cols="6">
                <v-btn class="campaign-btn" href="https://minden.co.jp/news/2026/05/27/10532" target="_blank" rel="noopener noreferrer" variant="text">
                    <v-img src="@/assets/campaignBtn/UPDATER.png" class="w-150-140" height="44" cover />
                </v-btn>
            </v-col> -->
            <!-- 生活エナジー -->
            <!-- <v-col class="flex-center max-w-200-170" cols="6">
                <v-btn class="campaign-btn" href="https://scenergy.co.jp/news/14835/" target="_blank" rel="noopener noreferrer" variant="text">
                    <v-img src="@/assets/campaignBtn/scenergy.jpg" width="150" cover />
                </v-btn>
            </v-col> -->
            <!-- JCOM -->
            <!-- <v-col class="flex-center max-w-200-170" cols="6">
                <v-btn class="campaign-btn" href="https://c.myjcom.jp/town/setagaya-green/2026.html" target="_blank" rel="noopener noreferrer" variant="text">
                    <v-img src="@/assets/campaignBtn/JCOM.jpg" width="100" cover />
                </v-btn>
            </v-col> -->
            <!-- オクトパス -->
            <!-- <v-col class="flex-center flex-column max-w-200-170" cols="6">
                <v-btn class="campaign-end-btn" href="https://octopusenergy.co.jp/affiliate/setagayaku-subsidy-2026-06-15000" target="_blank" rel="noopener noreferrer" variant="text" elevation="0">
                    <v-img src="@/assets/campaignBtn/octopus.svg" class="w-170-150" cover />
                </v-btn> -->
                <!-- <span class="font-14-12 mb-6">※受付終了しました</span> -->
            <!-- </v-col> -->
            <!-- 東急パワーサプライ -->
            <!-- <v-col class="flex-center max-w-200-170" cols="6">
                <v-btn class="campaign-btn" href="https://www.tokyu-ps.co.jp/campaign/setagaya/2026summer/?auid=308SKH" target="_blank" rel="noopener noreferrer" variant="text">
                    <v-img src="@/assets/campaignBtn/tokyu-ps.jpg" width="150" cover />
                </v-btn>
            </v-col>
        </v-row>
        <v-spacer class="spacing-h-100-40"/> -->
        <!-------------------------------------------------- 
            再エネ電力プランとは 
         -------------------------------------------------->
        <!-- 見出し -->
        <v-row class="flex-center-y" id="section-plan">
            <v-icon class="font-14-12 blue spacing-mr-12-8">mdi-circle</v-icon>
            <span class="font-30-22 text-left">再エネ電力プランとは？</span>
            <span class="font-18-12">(※2)</span>
        </v-row>
        <v-spacer class="spacing-h-32-24"/>
        <!-- 概要 -->
        <v-row class="font-22-18 blue">
            パートナー企業が提供する再エネ電力プランを選ぶことで、再生可能エネルギー由来の電気に切り替えられます。
        </v-row>
        <v-spacer class="spacing-h-24-24"/>
        <!-- 詳細 -->
        <v-row class="font-16-14" style="font-weight: normal !important;">
            多くのパートナー企業が太陽光発電や風力発電などの再生可能エネルギーを電源としたプランを用意しています。<br>
            再生可能エネルギー割合が100％のプランであれば、CO₂排出量実質ゼロの電気となります。なお、再エネプランには100％以外にも様々な割合のものがあります。
        </v-row>
        <v-spacer class="spacing-h-10-10"/>
        <v-row class="font-14-12" style="font-weight: normal !important;">
            ※各社の提供する電気は水力、火力、原子力、FIT電気などで構成されます。火力等の場合、非化石証書を付与して実質ゼロにしています。構成比率などは各社HPをご確認下さい。
        </v-row>
        <v-spacer class="spacing-h-40-24"/>
        <!-- イメージ -->
        <v-row class="flex-center">
            <img class="w-1000-350" :src="require('@/assets/fv/renewableEnergy.svg')" v-if="!isSm"/>
            <img class="w-1000-350" :src="require('@/assets/fv/sp-renewableEnergy.svg')" v-else/>
        </v-row>
        <v-spacer class="spacing-h-40-24"/>
        <v-row class="flex-center font-22-15">
            再生可能エネルギー由来の電力プランへの切り替えでCO₂排出が実質ゼロの電気を使えます。
        </v-row>
        <v-spacer class="spacing-h-100-80"/>
        <!-------------------------------------------------- 
            再エネ電力プラン利用までの流れ 
         -------------------------------------------------->
        <!-- 見出し -->
        <v-row class="flex-center-y" id="section-flow">
            <v-icon class="font-14-12 blue spacing-mr-12-8">mdi-circle</v-icon>
            <span class="font-30-22 text-left">再エネ電力プラン利用までの流れ</span>
        </v-row>
        <v-spacer class="spacing-h-32-24"/>
        <!-- イメージ -->
        <v-row class="flex-center">
            <img class="w-900-250" :src="require('@/assets/fv/cp-end-renewableEnergyFlow.svg')" v-if="!isSm"/>
            <img class="w-900-250" :src="require('@/assets/fv/sp-cp-end-renewableEnergyFlow.svg')" v-else/>
        </v-row>
        <v-spacer class="spacing-h-100-80"/>
        <!-------------------------------------------------- 
            よくあるご質問 
         -------------------------------------------------->
        <!-- 見出し -->
        <v-row class="flex-center-y" id="section-faq">
            <v-icon class="font-14-12 blue spacing-mr-12-8">mdi-circle</v-icon>
            <span class="font-30-22 text-left">よくあるご質問</span>
        </v-row>
        <v-spacer class="spacing-h-32-24"/>
        <!-- よくあるご質問：中身 -->
        <v-expansion-panels multiple elevation="0">
            <v-expansion-panel v-for="(faq, index) in faqList" :key="index" class="spacing-mb-8-8">
                <v-expansion-panel-title hide-actions>
                    <template #default="{ expanded }">
                        <!-- Ｑ + (質問) + 開閉ボタン -->
                        <div class="flex-center-y space-between" style="width: 100%;">
                        <div class="back-blue radius-5 spacing-pa-12-12 spacing-mr-12-12 font-18-16">Ｑ</div>
                        <div class="font-18-16 text-left" style="width: 70%;">{{ faq.question }}</div>
                        <v-spacer />
                        <div class="details-btn">
                            <v-icon class="font-18-10">
                                {{ expanded ? 'mdi-minus' : 'mdi-plus' }}
                            </v-icon>
                        </div>
                        </div>
                    </template>
                </v-expansion-panel-title>
                <v-expansion-panel-text>
                    <!-- Ａ + (回答) +  -->
                    <div class="flex-start-y" style="width: 100%;">
                        <span class="back-red radius-5 spacing-pa-12-12 spacing-mr-12-12 font-18-16">Ａ</span>
                        <span class="font-16-14 weight-normal" style="white-space: pre-line;">{{ faq.answer }}</span>
                    </div>
                </v-expansion-panel-text>
            </v-expansion-panel>
        </v-expansion-panels>
        <v-spacer class="spacing-h-32-24"/>
        <!-- 注釈 -->
        <v-row class="font-16-12" no-gutters>
            <div>
                <div class="weight-normal">※1&emsp;CO₂削減量の考え方については、<a href="/conditions"><u>試算条件</u></a>を参照してください。</div>
                <div class="weight-normal">※2&emsp;環境省 再エネスタート「再エネ電力プラン(個人向け)」より</div>
            </div>
        </v-row>
    </v-container>
    <v-spacer class="spacing-h-100-80"/>
    <!-- 9/30 キャンペーン終了対応に伴いコメントアウト -->
    <!-- <div class="bottom-fixed-banner flex-center md-h-54 ma-0 pa-0" v-if="!isSm">
        <a class="flex-center" rel="noopener noreferrer" target="_blank" style="color: white !important;">
            <p class="mr-2 md-22">
                最大15,000円分還元される、再エネでんき切替キャンペーン実施中！6/1から9/30まで！
            </p>
            <img :src="require('@/assets/fv/kaeruBanner.svg')" style="height: 70px; margin-bottom: 20px; align-self: flex-end !important;" />
        </a>
    </div>
    <div class="bottom-fixed-banner flex-center sm-h-min-60 ma-0 pa-2" @click.prevent="goToCampaignSection" v-else>
        <a class="flex-center" rel="noopener noreferrer" target="_blank" style="color: white !important;">
            <p class="mr-1 sm-16 text-center nowrap">
                最大15,000円分還元される、<br>
                再エネでんき切替キャンペーン実施中！<br>
                6/1から9/30まで！
            </p>
            <img :src="require('@/assets/fv/kaeruBanner.svg')"/>
        </a>
    </div> -->
</template>

<script setup>
import { ref, onMounted, computed, unref, nextTick, onUnmounted} from 'vue';
import { useRouter, useRoute } from 'vue-router';
import { useDisplay } from 'vuetify';
import './main.css';

const display = useDisplay();
const isSmDispLay = computed(() => display.smAndDown);
const isSm = unref(isSmDispLay);

// ===== ランダム表示パターン用 =====
const currentPattern = ref(null); // 'A' | 'B' | 'C'

// UTMパラメータを格納する変数
const utmCampaign = ref(null)

// スクロール関数（固定ヘッダー分を補正）
function scrollToTarget(id) {
  const headerOffset = isSm ? 90 : 60;
  const element = document.getElementById(id);

  if (element) {
    const offsetTop = element.getBoundingClientRect().top + window.scrollY - headerOffset;
    window.scrollTo({ top: offsetTop, behavior: 'smooth' });
  }
}

const faqList = ref([]);
const route = useRoute();
const router = useRouter();

const showFloating = ref(false)

onMounted(async () => {
    // 1. FAQデータ読み込み（あなたの既存処理）
    try {
        const response = await fetch('/faqData.json');
    if (!response.ok) throw new Error(`ステータスエラー: ${response.status}`);
        const data = await response.json();
        faqList.value = data.faqData;
    } catch (e) {
        console.error('FAQ読み込み失敗:', e);
    }

    // 2. scrollToクエリがあればスクロール（追加部分）
    const scrollToId = route.query.scrollTo;
    if (scrollToId) {
        nextTick(() => {
            scrollToTarget(scrollToId);
        });
    }

    // 3. パターンをランダムに決定（A〜C）
    // 初期値はブランク
    currentPattern.value = '';

    // 4. スマホ表示の場合、Google Analytics に表示パターンを送信
    // URLのクエリパラメータから取得
    utmCampaign.value = route.query.utm_campaign
    if (utmCampaign.value) {
        // 末尾1文字を取得
        currentPattern.value = utmCampaign.value.slice(-1)

        // 取得した値が 'a', 'b', 'c' のいずれかでない場合は、デフォルトで 'a' を設定
        if (!['a', 'b', 'c'].includes(currentPattern.value)) {
            currentPattern.value = 'a'
        }
    }

    // Google Analytics に表示パターンを送信
    window.gtag?.('event', 'view_pattern', {
        pattern: currentPattern.value
    });

    const target = document.getElementById('section-terms')

    const observer = new IntersectionObserver(
        (entries) => {
            if (entries[0].isIntersecting) {
            showFloating.value = false
            } else {
            showFloating.value = true   // section-terms が見えたら固定表示
            }
        },
        { threshold: 0.1 } // 少しでも見えたら発火
    )

    if (target) observer.observe(target)

    onUnmounted(() => {
        if (target) observer.unobserve(target)
    })
});

// function goToCampaignSection() {
//     scrollToTarget('section-campaign');
// }

function goToSearchWithDialog() {
    // スマホ表示の場合、Google Analytics に表示パターンを送信
    if (isSm) {
        window.gtag?.('event', 'click_pattern_button', {
            pattern: currentPattern.value
        });
    }

    router.push({ name: 'Search', query: { showDialog: 'true' } });
}
</script>


<style lang="scss">
@use "@/assets/styles/main" as *;
</style>
